import type { NavigateFunction } from "react-router";

// React 바깥(api/client 등)에서 라우터로 이동할 때 쓰는 얇은 레지스트리. router.tsx가 등록한다.
type Navigate = (to: string, opts?: { replace?: boolean }) => void;

let navigateImpl: Navigate | null = null;

export function registerNavigate(fn: Navigate | null): void {
  navigateImpl = fn;
}

export function navigateTo(to: string, opts?: { replace?: boolean }): void {
  if (navigateImpl) navigateImpl(to, opts);
  else if (typeof window !== "undefined") window.location.assign(to);
}

/** 히스토리가 있으면 뒤로, 직접 진입(웹 주소창·딥링크, idx 0)이면 fallback 으로 replace. */
export function backOr(navigate: NavigateFunction, fallback: string): void {
  const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
  if (idx > 0) void navigate(-1);
  else void navigate(fallback, { replace: true });
}
